import { useContext, useMemo } from "react";

import { useConfigChangesInlineActions } from "components/Actions/InlineActions/hooks/useConfigChangesInlineActions";
import Table from "components/Table";
import TableContext from "context/table/tableContext";
import { DEVICE_DETAILS_CONFIGURATION_CHANGES_COLUMNS } from "shared/constants/columns";
import {
    ENDPOINT_PATH_SEGMENTS,
    ENDPOINTS,
    FILTER_NAMES,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS
} from "shared/types/enums";

const History = () => {
    const { detailsData } = useContext(TableContext);

    const { inlineActions } = useConfigChangesInlineActions(false);

    const { imei } = detailsData;

    const innerTableQueryParams = useMemo(
        () => ({
            [FILTER_NAMES.DeviceImei]: imei
        }),
        [imei]
    );

    return (
        <Table
            name={TABLE_NAMES.ConfigurationChanges}
            customResource={`${ENDPOINTS.Devices}/${imei}${ENDPOINT_PATH_SEGMENTS.ConfigurationChanges}`}
            nameForFilters={TABLE_NAMES_WITH_FILTERS.DeviceDetailConfigChanges}
            isInnerTable
            hideSearch
            isNotSelectable
            initialColumns={DEVICE_DETAILS_CONFIGURATION_CHANGES_COLUMNS}
            inlineActions={inlineActions}
            idType={ID_TYPE.Id}
            sortFromNewest
            innerTableQueryParams={innerTableQueryParams}
        />
    );
};

export default History;
